import * as React from "react";
import {APP_URL, API_URL, SHOPIFY_REDIRECT_URL} from '../../../settings/local_settings';
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {ShopifyConnectButton} from "./ShopifyConnectButton";
import { withTranslation } from 'react-i18next';

export class ShopifyLinkComponentClass extends AuthUrlLinkBase {

    constructor(props) {
        super(props);
        this.state = {
            hasConnection: props.hasConnection,
            subdomain: props.subdomain,
            disabled: props.disabled
        };

        this.handleConnectClick = this.handleConnectClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.subdomain !== this.props.subdomain || prevProps.disabled !== this.props.disabled) {
            this.setState({ subdomain: this.props.subdomain, disabled: this.props.disabled });
        }
    }

    _getAuthURL(){
        const url = SHOPIFY_REDIRECT_URL.replace('{{store_subdomain}}', this.state.subdomain).replace('{{redirect_uri}}', encodeURIComponent(APP_URL+"connect-shopify"));
        return url;
    }

    _getDeleteUrl(){
        return API_URL + 'agency/shopify-connection/delete/';
    }

    renderConnectionButton() {
        return <ShopifyConnectButton onClick={this.handleConnectClick} disabled={this.state.disabled} />;
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('shopify_link.disconnect_from_shopify')}</button>
    }

    redirectToAuthPage() {
        window.location.href = this._getAuthURL();
    }

    handleConnectClick() {
        if (this.state.subdomain && !this.state.disabled) {
            this.redirectToAuthPage();
        }
    }
}

export const ShopifyLinkComponent = withTranslation()(ShopifyLinkComponentClass);
export default ShopifyLinkComponent;
